var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container"},[_c('a',{ref:"button",style:({ width: _vm.width, height: _vm.height }),on:{"mouseenter":_vm.mouseenter,"mousemove":_vm.mousemove,"mouseleave":_vm.mouseleave,"click":function($event){return _vm.goto(_vm.href)}}},[_vm._v(_vm._s(_vm.text))]),_c('div',{ref:"diffusedBlock",staticClass:"diffused-block"})])
}
var staticRenderFns = []

export { render, staticRenderFns }